type FormDataValuePrimitive =
  | Blob
  | File
  | string
  | number
  | boolean
  | null
  | undefined;

type FormDataValue = FormDataValuePrimitive | FormDataValuePrimitive[];

export function append(
  formData: FormData,
  key: string,
  value: FormDataValue,
): FormData;
export function append(
  formData: FormData,
  data: Record<string, FormDataValue>,
): FormData;
export function append(
  formData: FormData,
  dataOrKey: string | Record<string, FormDataValue>,
  value?: FormDataValue,
): FormData {
  if (typeof dataOrKey !== 'string') {
    Object.entries(dataOrKey).forEach(([k, v]) => {
      append(formData, k, v);
    });

    return formData;
  }

  const key = dataOrKey;

  if (value === null || value === undefined) {
    return formData;
  }

  if (Array.isArray(value)) {
    value.forEach((val) => {
      append(formData, key, val);
    });
  } else if (value instanceof File) {
    formData.append(key, value, value.name);
  } else if (value instanceof Blob) {
    formData.append(key, value);
  } else if (typeof value === 'string') {
    formData.append(key, value);
  } else {
    formData.append(key, String(value));
  }

  return formData;
}

export function createFormData(data: Record<string, FormDataValue>) {
  const formData = new FormData();
  append(formData, data);
  return formData;
}
